import { noop } from 'lodash';
import Grid, { IGridProps } from '../Grid';
import { S2, AB3 } from '../../theme';
import { encodedCursorSvg } from './cursorIcon';
import { mergeSX } from '../../services/helpers';

interface IBuildSXParams {
  truncate: boolean;
  disabled: boolean;
}

export interface IEditableContainerProps extends IGridProps {
  truncate?: boolean;
  disabled?: boolean;
}

const buildSX = ({ truncate, disabled }: IBuildSXParams) => ({
  borderRadius: '16px',
  wordBreak: truncate ? 'break-all' : 'initial',
  '&:hover': {
    backgroundColor: disabled ? 'initial' : S2,
    color: disabled ? 'initial' : AB3,
    cursor: disabled ? 'default' : `url("${encodedCursorSvg}") 16 16, pointer`,
  },
});

const EditableContainer = (props: IEditableContainerProps) => {
  const {
    children, truncate = true, disabled = false, onClick, sx, ...rest
  } = props;

  return (
    <Grid
      p={1}
      onClick={disabled ? noop : onClick}
      sx={mergeSX(buildSX({ truncate, disabled }), sx)}
      {...rest}
    >
      {children}
    </Grid>
  );
};

export default EditableContainer;
